const imgTeamGraphic1Poster1 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/0742553d-37fd-4197-a5b0-32f0c371bdff.png";
const img2026923372 = "./assets/figma/4035b339-96f6-4927-b1b2-b4d052e226e0.png";
const img2026923373 = "./assets/figma/7a6dc028-9361-4c44-964f-8aa3a1994c16.png";
const img12061 = "./assets/figma/00689bd6-b6e6-499a-a3c6-686dae57eabc.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgFrame99Png1 = "./assets/figma/4b3d3543-b0f2-427f-8bab-9e7f52420fa1.png";
const imgKakaoTalkPhoto20260915013619001Png1 = "./assets/figma/b9861cef-431c-456e-95c7-f22da12e759e.png";
const img102 = "./assets/figma/a9de13ed-f9c7-415c-b617-b56761a418e2.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/4329ab02-bd1e-473d-8da9-d8ecc919547f.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/46555a1a-7513-434c-85f5-7dfeec719be4.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic1Poster1() {
  return (
    <div className="s0 s1" data-node-id="875:1579" data-name="TEAM_GRAPHIC_1_POSTER1">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s1030 s441 s9 s10 s442" src={imgTeamGraphic1Poster1} />
        </div>
      </div>
      <div className="s2 s12 s13 s1031 s15" data-node-id="875:1581" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s1032 s22" data-node-id="875:1582">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:1583">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1584">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="875:1585">
            <p className="s39 s40">
              POSTER · A2 · 2<br aria-hidden />
              BRAND BOOK · B5 · 1
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1586">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1587">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1588">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="875:1589">
            <p className="s39 s40">강지운</p>
            <p className="s39 s40">김세원</p>
            <p className="s39 s40">노아연</p>
            <p className="s39">정다혜</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s1033 s54" data-node-id="875:1590">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s1034 s57" data-node-id="875:1591">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:1592">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1593">
          <p className="s39 s40">{`그래픽 1팀은 DING AI LAB의 Play Lab 콘셉트와 브랜드 시스템을 포스터와 브랜드북으로 시각화했다. `}</p>
          <p className="s39 s40">
            {`아이디어와 AI가 연결되고 실험되는 과정을 구슬과 투명한 파이프로 표현하고, Play·Flow·Connection·Modular의 네 가지 키워드를 중심으로 `}
            <br aria-hidden />
            {`일관된 브랜드 정체성을 구축했다. 브랜드북에는 8가지 AI별 Tube System과 응용 사례를 담았으며, 구슬이 튜브를 통과하면서 색·질감·형태를 `}
          </p>
          <p className="s39 s40">{`얻고 조합 순서에 따라 다른 결과로 발전하는 과정을 그래픽 시스템으로 구성했다. 오프화이트와 민트 계열의 색상, `}</p>
          <p className="s39">투명한 소재와 구조적인 레이아웃을 적용해 정돈된 실험실 분위기를 완성했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s943 s27 s29 s61 s1035 s54" data-node-id="875:1594">
        GRAPHIC 1
      </p>
      <div className="s2 s16 s17 s24 s944 s18 s19 s20 s1036 s66" data-node-id="875:1595">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="875:1596">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="875:1597">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1598">
            <div className="s192 s69 s659 s340 s0 s70 s198 s348 s71" data-node-id="875:1599" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1600" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1601" />
            <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:1602">
              POSTER 1
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1603">
            <div className="s192 s69 s946 s340 s0 s70 s198 s348 s71" data-node-id="875:1604" data-name="이미지 2026. 9. 2. 오후 3.37 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923372} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1605" />
            <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:1606" />
            <p className="s23 s192 s31 s94 s947 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:1607">
              POSTER 2
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1608">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="875:1609" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s7 s948 s9 s10 s949" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:1610" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1611" />
            <p className="s23 s192 s31 s94 s950 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:1612">
              CATALOG
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s951 s328 s1034 s952" data-node-id="875:1613" data-name="이미지 1206 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12061} />
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1614">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:1615" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1616">
          <div className="s111 s0 s28 s112" data-node-id="875:1617" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1622">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1623">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1624">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1625">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1626">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1627">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1628">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1629">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1630">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1631">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1632">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:1763">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:1764">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:1769" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
        <p className="s23 s31 s32 s27 s0 s28 s137 s138 s54" data-node-id="856:2685">
          GRAPHIC 1
        </p>
        <div className="s16 s17 s139 s1037 s18 s0 s28 s34" data-node-id="856:2691" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:2692" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:2693">
              POSTER1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:2694" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:2695">
              POATER2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:2696" data-name="TAB_CATALOG">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:2697">
              CATALOG
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <div className="s106 s2 s67 s126 s1038" data-node-id="875:1760">
        <div className="s2 s5 s1039 s153 s156 s157 s1038 s158" data-node-id="856:2689" />
        <p className="s23 s2 s31 s32 s1040 s27 s29 s160 s1041 s54" data-node-id="856:2690">
          POSTER1
        </p>
        <div className="s106 s2 s67 s1042 s1043" data-node-id="856:2699">
          <div className="s106 s2 s1044 s1042 s165 s4 s145 s146 s1043 s1045" data-node-id="856:2700">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s1046 s26 s1047 s27 s29 s1048 s1049" data-node-id="856:2701">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2702">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2703">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34" data-node-id="856:2704">
                <p className="s175 s40">새하얀 미래형 전시 공간 안에 설치된 세로형 기계 구조물. 화면 정중앙에 완벽한 좌우 대칭으로 배치되어 있으 며, 중앙에는 속이 비어 있는 거대한 투명 유리 원형 링 구조가 위치한다. 원형 링의 위아래로 투명한 유리관과 정교한 민트색 기계 부품이 수직으로 연결되어 있다.</p>
                <p className="s175 s40">기계 부품은 파스텔 민트와 청록 계열의 금속 소재이며, 투명 아크릴과 맑은 유리 소재가 함께 사용된다. 연결 부위에는 작고 섬세한 금색 볼트와 금속 장식이 배치되어 있어 정밀 기계 장치처럼 보인다. 중앙 원형 구조 위에 는 복잡한 민트색 연결 장치와 투명한 관이 이어지고, 천장에는 거대한 원형 민트색 구조물이 떠 있는 형태로 설 치되어 있다.</p>
                <p className="s175 s40">공간 전체는 부드러운 곡선 형태의 흰색 천장과 원형 구조로 구성되며, 민트빛과 옅은 시안 계열의 간접 LED 조명이 은은하게 빛난다. 하단의 투명 유리관은 둥근 흰색 바닥 플랫폼과 연결되어 있다.</p>
                <p className="s175">전체적으로 미래적이고 고급스러운 기술 전시 공간, 미니멀하고 깨끗한 분위기, 흰색과 민트색 중심의 컬러 팔 레트, 실험실보다는 프리미엄 전시관에 가까운 이미지. 넓은 흰색 여백, 부드러운 반사광, 은은한 그림자, 투명 유리의 섬세한 굴절과 반사 표현. 정면 시점, 카메라 왜곡 최소화, 완벽한 중앙 정렬, 좌우 대칭, 사실적인 3D 렌 더링, 초고해상도, 정교한 재질 표현, 시네마4D 및 옥테인 렌더 스타일, 세로형 이미지.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2705">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2706">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2707">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s1050 s1051 s1052 s1053" data-node-id="856:2709" data-name="Frame_99.png 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s1054 s1055 s9 s1056 s1057" src={imgFrame99Png1} />
          </div>
        </div>
        <div className="s2 s16 s17 s1058 s18 s227 s1059" data-node-id="875:1759">
          <div className="s362 s0 s28 s1060" data-node-id="856:2708" data-name="KakaoTalk_Photo_2026-09-15-01-36-19_001.png 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto20260915013619001Png1} />
          </div>
          <div className="s362 s0 s28 s1061" data-node-id="856:2710" data-name="10 2">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img102} />
          </div>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:134" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}